import { roomsAvailabilityAtom as T, setExtrasToCartItemAtom as l, setCityTaxesToCartAtom as u, updateRoomInCartItemsPriceAtom as C } from "./index34.mjs";
import { setToastAtom as p } from "./index65.mjs";
import { useAtomValue as A, useSetAtom as t } from "jotai";
const v = () => {
  const r = A(T), a = t(l), e = t(p), i = t(u), m = t(C);
  return {
    roomsAvailability: r,
    setExtrasToCart: a,
    setToast: e,
    addMandatoryExtrasToCart: (c, o) => {
      const {
        mandatory_extras: n = [],
        city_taxes: s,
        city_taxes_included: x,
        price_summary: d
      } = c;
      m(o, d.allocated_price), n.forEach((y) => {
        a({
          extra: { ...y, amount: 1 },
          cartItemId: o,
          isOptional: !1
        });
      }), s && i({
        cityTaxes: s,
        cityTaxIncluded: x,
        cartItemId: o
      });
    }
  };
};
export {
  v as useExtras
};
